import KeyboardHandler, { Key } from "./KeyboardHandler";
export { KeyboardHandler, Key };
export default KeyboardHandler;
